<template>
  <div class="my-pagination">
    <div
      class="my-pagination__item"
      :class="{
        'my-pagination__item--active': value === i || doubt.includes(i+1),
        'my-pagination__item--answered': items[i].givenAnswer > -1 && !doubt.includes(i+1)
      }"
      v-for="(item, i) in items"
      :key="i"
      @click="$emit('input', i)"
    >
      <strong v-show="value === i">{{ i + 1 }}</strong>
      <span v-show="value != i">{{ i + 1 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    doubt: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style>
.my-pagination {
  display: flex;
  flex-wrap: wrap;
}

.my-pagination__item {
  width: 19px;
  height: 19px;
  border: solid 1px #b4b4b4;
  border-radius: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  line-height: 1;
  color: #b4b4b4;
  margin-right: 6px;
  margin-bottom: 6px;
  cursor: pointer;
}

.my-pagination__item:hover {
  border-color: #ff7e1f;
}

.my-pagination__item--answered {
  border-color: #009feb;
  background-color: #009feb;
  color: #fff;
}

.my-pagination__item--active {
  border-color: #ff7e1f;
  background-color: #ff7e1f;
  color: #fff;
}
</style>
